import { useEffect, useState } from "react"
import { Edit, User } from "react-feather"
import { Link } from "react-router-dom"
import {
  Button,
  Card,
  Label,
  Nav,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Spinner,
  TabContent,
  TabPane
} from "reactstrap"
import { getAllFromController } from "@lib/api"
import { convertNameToColor, dateISO } from "@lib/util"
// ** Custom Components
import Avatar from "@components/avatar"
import BasicTimeline from "../visits/timeline/BasicTimeline"

const DrawerPerson = ({ personId, isDrawerOpen, toggleDrawer }) => {
  const [person, setPerson] = useState()
  const [activeTab, setActiveTab] = useState(1)

  const H5_CLASSES = "border-1 border-bottom-primary mt-5 pb-2"

  useEffect(() => {
    getAllFromController(`Persons/${personId}`, "crm").then((personData) => {
      personData.addresses.forEach((address) => {
        getAllFromController(`States/${address.city.stateId}`, "crm").then((stateData) => {
          address.country = stateData.country.nameEN
        })
      })
      setPerson(personData)
    })
  }, [personId])

  return (
    <Offcanvas
      direction="end"
      isOpen={isDrawerOpen}
      toggle={toggleDrawer}
      style={{ minWidth: "36rem" }}
    >
      {person ? (
        <>
          <OffcanvasHeader className="bg-light-primary">
            <User size={18} className="me-50" /> ID {personId}
          </OffcanvasHeader>
          <OffcanvasBody className="mx-0 flex-grow-0 start">
            <Nav pills fill>
              <NavItem>
                <NavLink active={activeTab === 1} onClick={() => setActiveTab(1)}>
                  Profile
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink active={activeTab === 2} onClick={() => setActiveTab(2)}>
                  Timeline
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent className="py-2" activeTab={activeTab}>
              <TabPane tabId={1}>
                <Card className="p-3">
                  <center className="my-5">
                    <Avatar
                      size="xl"
                      color={`light-${convertNameToColor(person.name)}`}
                      content={`${person.name} ${person.firstName}`}
                      className="mb-2"
                      initials
                    />
                    <h3>
                      {person.name.toUpperCase()} {person.firstName}
                    </h3>
                  </center>

                  <div className="d-flex justify-content-end">
                    <Link to={`/CRM/Visits/${personId}`}>
                      <Button color="light" size="sm" className="my-1">
                        <Edit size={18} className="me-50" />
                        Edit
                      </Button>
                    </Link>
                  </div>

                  <h5 className={H5_CLASSES}>Personal information</h5>
                  <Label className="fw-bolder">Title</Label>
                  <p>{person.title.name}</p>
                  <Label className="fw-bolder">Gender</Label>
                  <p>{person.gender.name}</p>
                  <Label className="fw-bolder">Language</Label>
                  <p>{person.language.name}</p>
                  <Label className="fw-bolder">Birthdate</Label>
                  <p>
                    {!person.isBirthDateExact && "~ "}
                    {dateISO(person.birthdate, true)}
                  </p>
                  <h5 className={H5_CLASSES}>Contact</h5>
                  <Label className="fw-bolder">Email(s)</Label>
                  <p>
                    {
                      // prettier-ignore
                      person.emails?.length > 0 ? person.emails.map((email) => email.address).join(", ") : "None"
                    }
                  </p>
                  <Label className="fw-bolder">Phone number(s)</Label>
                  <p>
                    {
                      // prettier-ignore
                      person.phones?.length > 0 ? person.phones.map((phone) => phone.number).join(", ") : "None"
                    }
                  </p>
                  <h5 className={H5_CLASSES}>Postal address</h5>
                  {person.addresses?.length > 0 ? (
                    person.addresses.map((address) => (
                      <div key={address.id}>
                        <Label className="fw-bolder">{address.type.name} address</Label>
                        <p>
                          {address.street} {address.additional}
                          <br />
                          {address.postCode} {address.city.name}
                          <br />
                          {address.country}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p>None</p>
                  )}
                  <h5 className={H5_CLASSES}>Others</h5>
                  <Label className="fw-bolder">Categories</Label>
                  <p>
                    {
                      // prettier-ignore
                      person.categories?.length > 0 ? person.categories.map((category) => category.name).join(", ") : "None"
                    }
                  </p>
                  <Label className="fw-bolder">Tags</Label>
                  <p>
                    {person.tags?.length > 0 ? person.tags.map((tag) => tag).join(", ") : "None"}
                  </p>
                  <Label className="fw-bolder">Annual income</Label>
                  <p>{person.annualIncome}</p>
                </Card>
              </TabPane>
              <TabPane tabId={2}>
                <BasicTimeline personId={personId} isAdminCRM={false} editMode={false} />
              </TabPane>
            </TabContent>
          </OffcanvasBody>
        </>
      ) : (
        <OffcanvasBody className="my-auto mx-auto flex-grow-0 text-center">
          <Spinner color="primary" />
          <p>Loading person</p>
        </OffcanvasBody>
      )}
    </Offcanvas>
  )
}

export default DrawerPerson
